<template>
  <div>
    <Simulation
      :simulationDevices="simulationDevices"
      :busConfigurations="busConfigurations"
      simulationLabel="ResolDeltaSolSlt_1d05"
    >
    </Simulation>
  </div>
</template>

<script>
import Simulation from '@/components/Simulation';
import ResolDeltaSolSlt_1d05 from '@/device-products/ResolDeltaSolSlt_1d05.vue';

export default {
  components: {
    Simulation,
  },

  data: () => ({
    busConfigurations: [
      {
        label: 'GP', connections: [
        ],
      },
    ],
    simulationDevices: [
      { id: 0, component: ResolDeltaSolSlt_1d05, deviceLabel: null },
    ],
  }),
};
</script>

<style>

</style>
